import React from "react";
import Header from "./Header";
import Menu from "./Menu";
import styles from "./Layout.module.scss";
import { InstallPWA } from "PWA/PWAPrompt";
import { AddEmailPrompt } from "Profile/components/AddEmailPrompt";

export interface ILayoutProps {
  children: React.ReactNode | React.ReactNode[];
}

const Layout = ({ children }: ILayoutProps) => {
  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>{children}</div>
      <AddEmailPrompt />
      <InstallPWA />
      <Menu />
    </div>
  );
};

export default Layout;
